"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PricingInstrumentEvent = exports.StreamEvent = exports.MARKET_PRICE_DOMAIN = void 0;
const stream_1 = require("../../delivery/stream");
exports.MARKET_PRICE_DOMAIN = 'MarketPrice';
exports.StreamEvent = Object.assign({}, stream_1.OMMStreamEvent);
exports.PricingInstrumentEvent = Object.assign({}, stream_1.OMMStreamEvent);
